import { configure, customMap, event as gtagEvent } from "vue-gtag";
import { EnvProvider, Envs } from '@/utils/EnvProvider';
import { APP_WINDOW_KEY } from '@/config/app';
import type { App } from 'vue';
import router from '@/router';

const buildVersion = '__VERSION__';
const buildHash = '__HASH__';
const version = `${buildVersion}-${buildHash}`;

export default async (app: App) => {
  if (EnvProvider.env !== Envs.Cloud) return;

  const gTagId = window?.[APP_WINDOW_KEY]?.FB_MEASUREMENT_ID;
  if (!gTagId) return;

  configure({
    appName: 'QxControl',
    tagId: gTagId,
    // DEV NOTE :: see App.vue for `addGtag` within `onMounted`
    initMode: 'manual',
    pageTracker: {
      router,
      useScreenview: true,
      template: (to) => ({
        page_title: (to?.name || '') as string,
        page_path: to?.fullPath || ''
      }),
    },
    hooks: {
      /**
       * Called when the gtag.js script successfully loads.
       */
      'script:loaded': () => {
        customMap({ dimension2: 'version' });
        gtagEvent('client', { version });
      },
      /**
       * Called when the gtag.js script fails to load.
       * @param error - The error encountered during script loading.
       */
      'script:error': (error) => {
        console.error('### gtag - script:error', { error });
      }
    }
  })

  return;
};
